import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClinicalReportComponent } from './clinical-report.component';
import { ListModule } from './list/list.module';
import { EditModule } from './edit/edit.module';

const ROUTES: Routes = [
  {
    path: 'clinicalReport',
    component: ClinicalReportComponent,
    loadChildren: (): any => ListModule,
    pathMatch: 'full',
  },
  {
    path: 'clinicalReport/new',
    component: ClinicalReportComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
  {
    path: 'clinicalReport/:id/edit',
    component: ClinicalReportComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  declarations: [ClinicalReportComponent],
  exports: [ClinicalReportComponent],
})
export class ClinicalReportModule {}
